import { PrimeDiamondMark } from './PrimeDiamondMark.jsx';
import './primeSummoning.css';

/**
 * The sign-in hero brand lockup: the nested-diamond mark beside the PRIME
 * wordmark, per the "PRIME identity — nested diamond" primary lockup.
 *
 * The mark here is always the vector one — the WebGL summon plays over this
 * slot and then hands off to it, so this is the thing that persists. That is
 * why there is no WebGL-absent fallback branch any more: a machine with no GPU
 * simply never sees the summon and gets this, unchanged.
 *
 * `markVisible` is false only for the moment a full summon is still playing;
 * the mark is faded in as the canvas fades out.
 *
 * `DHA PRIME` and the expansion stay in the DOM as screen-reader-only text so
 * assistive tech, the brand-copy scan and the `.login-acronym` specs all still
 * see them. The visible brand is the lockup.
 */
export function LoginBrandLockup({ kicker, slotRef, markVisible = true }) {
  return (
    <div className="login-brand-copy login-brand-copy--mark">
      {kicker ? <div className="login-kicker">{kicker}</div> : null}

      <div className="login-brand-lockup" aria-hidden="true">
        {/* The summon is painted over this box by the fixed intro layer, and
            resolves into the very mark rendered inside it. */}
        <div
          ref={slotRef}
          className={`login-brand-mark-slot${markVisible ? ' is-visible' : ''}`}
          data-testid="login-brand-mark-slot"
          data-mark-visible={markVisible ? 'true' : 'false'}
        >
          <PrimeDiamondMark fluid />
        </div>
        <span className="login-brand-wordmark" data-testid="login-brand-wordmark">
          PRIME
        </span>
      </div>

      <h1 className="login-brand-sr">DHA PRIME</h1>
      <div className="login-acronym login-brand-sr">
        Program Resource and Intelligence Management Engine
      </div>
    </div>
  );
}

export default LoginBrandLockup;
